import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.HeaderSection', {
    title: 'Getting started with ApprovalMax',
    greeting: 'Hey {name},',
    useCase: 'Follow these steps to {useCase} for ',
});
